module.exports = __webpack_public_path__ + "media/cryoscorch.43c535d0.mp3";